if (!customElements.get('collection-filter')) {
  class CollectionFilter extends HTMLElement {
    constructor() {
      super();
    }

    extractActiveFilters() {
      const activeFilterItems = this.querySelectorAll('.filtering-list__item--active');
      const filters = new Map();
      let sortValue = '';

      activeFilterItems.forEach(item => {
        const tagFilter = item.dataset.tagFilter;
        const value = item.dataset.value;
        const group = item.dataset.group;

        if (value && value.includes('?sort_by')) {
          const sortMatch = value.match(/sort_by=([^&]+)/);
          if (sortMatch) {
            sortValue = sortMatch[1];
          }
        } else if (tagFilter && group) {
          const tagParts = tagFilter.split(':');
          if (tagParts.length >= 3) {
            const filterValue = tagParts[2].replace('+', '').toLowerCase();

            if (!filters.has(group)) {
              filters.set(group, []);
            }
            filters.get(group).push(filterValue);
          }
        } else if (value && value.includes('size-')) {
          const sizeValue = value.replace('size-', '').replace('+', '');
          if (!filters.has('size')) {
            filters.set('size', []);
          }
          filters.get('size').push(sizeValue);
        }
      });

      return { filters, sortValue };
    }

    updateURLWithFilters() {
      const url = new URL(window.location);
      const { filters, sortValue } = this.extractActiveFilters();

      const existingParams = Array.from(url.searchParams.keys());
      existingParams.forEach(param => {
        if (param.startsWith('filter_') || param === 'sort_by') {
          url.searchParams.delete(param);
        }
      });

      filters.forEach((values, groupName) => {
        if (values.length > 0) {
          url.searchParams.set(`filter_${groupName}`, values.join(','));
        }
      });

      if (sortValue) {
        url.searchParams.set('sort_by', sortValue);
      }

      window.history.replaceState({}, '', url.toString());
    }

    clearURLFilters() {
      const url = new URL(window.location);
      const existingParams = Array.from(url.searchParams.keys());

      existingParams.forEach(param => {
        if (param.startsWith('filter_') || param === 'sort_by') {
          url.searchParams.delete(param);
        }
      });

      window.history.replaceState({}, '', url.toString());
    }

    restoreFiltersFromURL() {
      const url = new URL(window.location);
      const urlParams = url.searchParams;
      let hasActiveFilters = false;

      urlParams.forEach((value, key) => {
        if (key.startsWith('filter_')) {
          const filterType = key.replace('filter_', '');
          const filterValues = value.split(',');

          filterValues.forEach(filterValue => {
            const matchingFilters = this.querySelectorAll(`[data-group="${filterType}"]`);

            matchingFilters.forEach(filter => {
              const tagFilter = filter.dataset.tagFilter;
              if (tagFilter && tagFilter.toLowerCase().includes(filterValue.toLowerCase())) {
                filter.classList.add('filtering-list__item--active');
                hasActiveFilters = true;
              }
            });

            if (filterType === 'size') {
              const sizeFilter = this.querySelector(`[data-value="size-${filterValue}+"]`);
              if (sizeFilter) {
                sizeFilter.classList.add('filtering-list__item--active');
                hasActiveFilters = true;
              }
            }
          });
        } else if (key === 'sort_by') {
          const sortFilter = this.querySelector(`[data-value="?sort_by=${value}"]`);
          if (sortFilter) {
            sortFilter.classList.add('filtering-list__item--active');
            hasActiveFilters = true;
          }
        }
      });

      if (hasActiveFilters) {
        setTimeout(() => {
          const applyButton = this.querySelector('.fullpageCollectionFilter__buttonApply');
          if (applyButton) {
            applyButton.click();
          }
        }, 100);
      }
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', () => this.restoreFiltersFromURL());
      } else {
        this.restoreFiltersFromURL();
      }
    }

  }

  customElements.define('collection-filter', CollectionFilter);
}

window.updateURLWithFilters = function() {
  const collectionFilter = document.querySelector('collection-filter');
  if (collectionFilter && collectionFilter.updateURLWithFilters) {
    collectionFilter.updateURLWithFilters();
  }
};
